export const COUNTRY_CODE_MAP = {
  isUS: [
    'US',
    'USA',
    'AS',
    'ASM',
    'GU',
    'GUM',
    'MP',
    'MNP',
    'PR',
    'PRI',
    'VI',
    'VIR',
    'UM',
    'UMI',
    'MH',
    'MHL',
  ],
  isUK: ['GB', 'GBR'],
  isCA: ['CA', 'CAN'],
  isBR: ['BR', 'BRA'],
  isHK: ['HK', 'HKG'],
  isAU: ['AU', 'AUS'],
  isRUS: ['RU', 'RUS'],
  isEEA: [
    'ITA',
    'IT',
    'DEU',
    'DE',
    'ESP',
    'ES',
    'ROU',
    'RO',
    'NLD',
    'NL',
    'POL',
    'PL',
    'BEL',
    'BE',
    'PRT',
    'PT',
    'SWE',
    'SE',
    'IRL',
    'IE',
    'GRC',
    'GR',
    'AUT',
    'AT',
    'HUN',
    'HU',
    'NOR',
    'NO',
    'DNK',
    'DK',
    'FIN',
    'FI',
    'FRA',
    'FR',
    'BGR',
    'BG',
    'HRV',
    'HR',
    'CYP',
    'CY',
    'CZE',
    'CZ',
    'EST',
    'EE',
    'ISL',
    'IS',
    'LVA',
    'LV',
    'LIE',
    'LI',
    'LTU',
    'LT',
    'LUX',
    'LU',
    'MLT',
    'MT',
    'SVK',
    'SK',
    'SVN',
    'SI',
    'CHE',
    'CH',
  ],
  isLATAM: [
    'BRA',
    'BR',
    'COL',
    'CO',
    'MEX',
    'MX',
    'ARG',
    'AR',
    'PER',
    'PE',
    'VEN',
    'VE',
    'CHL',
    'CL',
    'GTM',
    'GT',
    'ECU',
    'EC',
    'BOL',
    'BO',
    'CUB',
    'CU',
    'HTI',
    'HT',
    'DOM',
    'DO',
    'HND',
    'HN',
    'PRY',
    'PY',
    'SLV',
    'SV',
    'NIC',
    'NI',
    'CRI',
    'CR',
    'PAN',
    'PA',
    'URY',
    'UY',
    'PRI',
    'PR',
  ],
  isARE: ['ARE', 'AE'],
  isKOR: ['KOR', 'KR'],
  isSG: ['SG', 'SGP'],
  isCYM: ['CYM', 'KY'],
};

/**
 * @see https://help.crypto.com/en/articles/4894470-derivatives-trading-geo-restrictions
 * JSON.stringify(Array.from(document.querySelector('.intercom-interblocks-table').querySelectorAll('tr')).filter((item, index) => index >= 1).map(item => item.querySelectorAll('td')[1].querySelector('p').innerText.split('/').map(item => item.trim())).filter(item => !!item[0]).flat())
 */
export const DERIVATIVES_RESTRICTED_COUNTRY_CODES = [
  'AF',
  'AFG',
  'AS',
  'ASM',
  'AU',
  'AUS',
  'AT',
  'AUT',
  'BD',
  'BGD',
  'BE',
  'BEL',
  'BO',
  'BOL',
  'BR',
  'BRA',
  'BG',
  'BGR',
  'BI',
  'BDI',
  'CA',
  'CAN',
  'BQ',
  'BES',
  'CF',
  'CAF',
  'CD',
  'COD',
  'HR',
  'HRV',
  'CU',
  'CUB',
  'CY',
  'CYP',
  'CZ',
  'CZE',
  'DK',
  'DNK',
  'EC',
  'ECU',
  'ER',
  'ERI',
  'EE',
  'EST',
  'FI',
  'FIN',
  'FR',
  'FRA',
  'GF',
  'GUF',
  'PF',
  'PYF',
  'DE',
  'DEU',
  'GR',
  'GRC',
  'GU',
  'GUM',
  'GN',
  'GIN',
  'GW',
  'GNB',
  'HU',
  'HUN',
  'IS',
  'ISL',
  'IR',
  'IRN',
  'IQ',
  'IRQ',
  'IE',
  'IRL',
  'IT',
  'ITA',
  'JP',
  'JPN',
  'KG',
  'KGZ',
  'LV',
  'LVA',
  'LB',
  'LBN',
  'LY',
  'LBY',
  'LI',
  'LIE',
  'LU',
  'LUX',
  'ML',
  'MLI',
  'MT',
  'MLT',
  'MQ',
  'MTQ',
  'UMI',
  'MM',
  'MMR',
  'NA',
  'NAM',
  'NP',
  'NPL',
  'NL',
  'NLD',
  'NC',
  'NCL',
  'KP',
  'PRK',
  'MP',
  'MNP',
  'NO',
  'NOR',
  'CN',
  'CHN',
  'PL',
  'POL',
  'PT',
  'PRT',
  'PR',
  'PRI',
  'RE',
  'REU',
  'RO',
  'ROU',
  'MF',
  'MAF',
  'SK',
  'SVK',
  'SI',
  'SVN',
  'SO',
  'SOM',
  'ZA',
  'ZAF',
  'SS',
  'SSD',
  'ES',
  'ESP',
  'PM',
  'SPM',
  'LC',
  'LCA',
  'SD',
  'SDN',
  'SE',
  'SWE',
  'CH',
  'CHE',
  'SY',
  'SYR',
  'TW',
  'TWN',
  'GB',
  'GBR',
  'US',
  'USA',
  'VI',
  'VIR',
  'VA',
  'VAT',
  'VE',
  'VEN',
  'YE',
  'YEM',
  'ZW',
  'ZWE',
];

export const STAKING_RESTRICTED_COUNTRY_CODES = [
  'US',
  'USA',
  'AF',
  'AFG',
  'BD',
  'BGD',
  'BO',
  'BOL',
  'BI',
  'BDI',
  'AS',
  'ASM',
  'AU',
  'AUS',
  'AT',
  'AUT',
  'CA',
  'CAN',
  'CF',
  'CAF',
  'CN',
  'CHN',
  'CD',
  'COD',
  'CU',
  'CUB',
  'FI',
  'FIN',
  'GR',
  'GUF',
  'PF',
  'PYF',
  'FR',
  'FRA',
  'EC',
  'ECU',
  'DE',
  'DEU',
  'GI',
  'GIB',
  'GP',
  'GLP',
  'GN',
  'GIN',
  'GW',
  'GNB',
  'GT',
  'GTM',
  'HK',
  'HKG',
  'IR',
  'IRN',
  'IQ',
  'IRQ',
  'MT',
  'MLT',
  'MQ',
  'MTQ',
  'MM',
  'MMR',
  'NL',
  'NLD',
  'NC',
  'NCL',
  'NZ',
  'NZL',
  'NO',
  'NOR',
  'KP',
  'PRK',
  'KG',
  'KGZ',
  'LB',
  'LBN',
  'LY',
  'LBY',
  'ML',
  'MLI',
  'MP',
  'MNP',
  'NA',
  'NAM',
  'NP',
  'NPL',
  'PR',
  'PRI',
  'RE',
  'REU',
  'SX',
  'SG',
  'SGP',
  'SO',
  'SOM',
  'SD',
  'SDN',
  'KR',
  'KOR',
  'ES',
  'ESP',
  'PM',
  'SPM',
  'SY',
  'SYR',
  'SE',
  'SWE',
  'TW',
  'TWN',
  'CH',
  'CHE',
  'TH',
  'THA',
  'GB',
  'GBR',
  'VI',
  'VIR',
  'VE',
  'VEN',
  'YE',
  'YEM',
  'ZW',
  'ZWE',
  'SS',
  'SSD',
  'BE',
  'BEL',
  'BG',
  'BGR',
  'HR',
  'HRV',
  'CY',
  'CYP',
  'CZ',
  'CZE',
  'DK',
  'DNK',
  'ER',
  'ERI',
  'EE',
  'EST',
  'GR',
  'GRC',
  'HU',
  'HUN',
  'IS',
  'ISL',
  'IE',
  'IRL',
  'IT',
  'ITA',
  'LV',
  'LVA',
  'LI',
  'LIE',
  'LU',
  'LUX',
  'LT',
  'LTU',
  'PL',
  'POL',
  'PT',
  'PRT',
  'RO',
  'ROU',
  'LC',
  'LCA',
  'SK',
  'SVK',
  'SI',
  'SVN',
  'PM',
  'SPM',
  'UA',
  'UKR',
  'RU',
  'RUS',
];

export const COUNTRY_CODES = {
  AD: 'AND',
  AE: 'ARE',
  AF: 'AFG',
  AG: 'ATG',
  AI: 'AIA',
  AL: 'ALB',
  AM: 'ARM',
  AO: 'AGO',
  AQ: 'ATA',
  AR: 'ARG',
  AS: 'ASM',
  AT: 'AUT',
  AU: 'AUS',
  AW: 'ABW',
  AX: 'ALA',
  AZ: 'AZE',
  BA: 'BIH',
  BB: 'BRB',
  BD: 'BGD',
  BE: 'BEL',
  BF: 'BFA',
  BG: 'BGR',
  BH: 'BHR',
  BI: 'BDI',
  BJ: 'BEN',
  BL: 'BLM',
  BM: 'BMU',
  BN: 'BRN',
  BO: 'BOL',
  BQ: 'BES',
  BR: 'BRA',
  BS: 'BHS',
  BT: 'BTN',
  BV: 'BVT',
  BW: 'BWA',
  BY: 'BLR',
  BZ: 'BLZ',
  CA: 'CAN',
  CC: 'CCK',
  CF: 'CAF',
  CH: 'CHE',
  CL: 'CHL',
  CM: 'CMR',
  CO: 'COL',
  CR: 'CRI',
  CU: 'CUB',
  CV: 'CPV',
  CX: 'CXR',
  CY: 'CYP',
  CZ: 'CZE',
  DE: 'DEU',
  DJ: 'DJI',
  DK: 'DNK',
  DM: 'DMA',
  DO: 'DOM',
  DZ: 'DZA',
  EC: 'ECU',
  EE: 'EST',
  EG: 'EGY',
  EH: 'ESH',
  ER: 'ERI',
  ES: 'ESP',
  FI: 'FIN',
  FJ: 'FJI',
  FK: 'FLK',
  FM: 'FSM',
  FO: 'FRO',
  FR: 'FRA',
  GA: 'GAB',
  GD: 'GRD',
  GE: 'GEO',
  GF: 'GUF',
  GH: 'GHA',
  GI: 'GIB',
  GL: 'GRL',
  GN: 'GIN',
  GP: 'GLP',
  GQ: 'GNQ',
  GR: 'GRC',
  GS: 'SGS',
  GT: 'GTM',
  GU: 'GUM',
  GW: 'GNB',
  GY: 'GUY',
  HK: 'HKG',
  HM: 'HMD',
  HN: 'HND',
  HR: 'HRV',
  HT: 'HTI',
  HU: 'HUN',
  ID: 'IDN',
  IE: 'IRL',
  IL: 'ISR',
  IM: 'IMN',
  IN: 'IND',
  IO: 'IOT',
  IQ: 'IRQ',
  IR: 'IRN',
  IS: 'ISL',
  IT: 'ITA',
  JE: 'JEY',
  JM: 'JAM',
  JO: 'JOR',
  JP: 'JPN',
  KH: 'KHM',
  KI: 'KIR',
  KM: 'COM',
  KW: 'KWT',
  KY: 'CYM',
  LB: 'LBN',
  LI: 'LIE',
  LK: 'LKA',
  LR: 'LBR',
  LS: 'LSO',
  LT: 'LTU',
  LU: 'LUX',
  LV: 'LVA',
  LY: 'LBY',
  MA: 'MAR',
  MC: 'MCO',
  MD: 'MDA',
  ME: 'MNE',
  MF: 'MAF',
  MG: 'MDG',
  MH: 'MHL',
  MK: 'MKD',
  ML: 'MLI',
  MM: 'MMR',
  MO: 'MAC',
  MQ: 'MTQ',
  MR: 'MRT',
  MS: 'MSR',
  MT: 'MLT',
  MV: 'MDV',
  MW: 'MWI',
  MX: 'MEX',
  MY: 'MYS',
  NA: 'NAM',
  NE: 'NER',
  NF: 'NFK',
  NG: 'NGA',
  NI: 'NIC',
  NL: 'NLD',
  NO: 'NOR',
  NP: 'NPL',
  NR: 'NRU',
  OM: 'OMN',
  PA: 'PAN',
  PE: 'PER',
  PF: 'PYF',
  PG: 'PNG',
  PH: 'PHL',
  PK: 'PAK',
  PL: 'POL',
  PN: 'PCN',
  PR: 'PRI',
  PS: 'PSE',
  PW: 'PLW',
  PY: 'PRY',
  QA: 'QAT',
  RE: 'REU',
  RO: 'ROU',
  RS: 'SRB',
  RU: 'RUS',
  RW: 'RWA',
  SB: 'SLB',
  SC: 'SYC',
  SD: 'SDN',
  SE: 'SWE',
  SG: 'SGP',
  SI: 'SVN',
  SJ: 'SJM',
  SK: 'SVK',
  SL: 'SLE',
  SM: 'SMR',
  SN: 'SEN',
  SO: 'SOM',
  SR: 'SUR',
  SS: 'SSD',
  ST: 'STP',
  SV: 'SLV',
  SY: 'SYR',
  SZ: 'SWZ',
  TC: 'TCA',
  TD: 'TCD',
  TG: 'TGO',
  TH: 'THA',
  TK: 'TKL',
  TL: 'TLS',
  TN: 'TUN',
  TO: 'TON',
  TR: 'TUR',
  TV: 'TUV',
  TZ: 'TZA',
  UA: 'UKR',
  UG: 'UGA',
  US: 'USA',
  UY: 'URY',
  VA: 'VAT',
  VE: 'VEN',
  VG: 'VGB',
  VI: 'VIR',
  VN: 'VNM',
  WF: 'WLF',
  WS: 'WSM',
  YE: 'YEM',
  YT: 'MYT',
  ZA: 'ZAF',
  ZM: 'ZMB',
  ZW: 'ZWE',
  CN: 'CHN',
  CG: 'COG',
  CD: 'COD',
  MZ: 'MOZ',
  GG: 'GGY',
  GM: 'GMB',
  MP: 'MNP',
  ET: 'ETH',
  NC: 'NCL',
  VU: 'VUT',
  TF: 'ATF',
  NU: 'NIU',
  UM: 'UMI',
  CK: 'COK',
  GB: 'GBR',
  TT: 'TTO',
  VC: 'VCT',
  TW: 'TWN',
  NZ: 'NZL',
  SA: 'SAU',
  LA: 'LAO',
  KP: 'PRK',
  KR: 'KOR',
  PT: 'PRT',
  KG: 'KGZ',
  KZ: 'KAZ',
  TJ: 'TJK',
  TM: 'TKM',
  UZ: 'UZB',
  KN: 'KNA',
  PM: 'SPM',
  SH: 'SHN',
  LC: 'LCA',
  MU: 'MUS',
  CI: 'CIV',
  KE: 'KEN',
  MN: 'MNG',
};

export const EEA_COUNTRY_LIST = [
  'ITA',
  'DEU',
  'ESP',
  'ROU',
  'NLD',
  'POL',
  'BEL',
  'PRT',
  'SWE',
  'IRL',
  'GRC',
  'AUT',
  'HUN',
  'NOR',
  'DNK',
  'FIN',
  'FRA',
  'BGR',
  'HRV',
  'CYP',
  'CZE',
  'EST',
  'ISL',
  'LVA',
  'LIE',
  'LTU',
  'LUX',
  'MLT',
  'SVK',
  'SVN',
  'CHE',
];

export const COUNTRY_OPTIONS = [
  {
    text: 'Afghanistan',
    value: 'AFG',
  },
  {
    text: 'Albania',
    value: 'ALB',
  },
  {
    text: 'Algeria',
    value: 'DZA',
  },
  {
    text: 'American Samoa',
    value: 'ASM',
  },
  {
    text: 'Andorra',
    value: 'AND',
  },
  {
    text: 'Angola',
    value: 'AGO',
  },
  {
    text: 'Anguilla',
    value: 'AIA',
  },
  {
    text: 'Antarctica',
    value: 'ATA',
  },
  {
    text: 'Antigua and Barbuda',
    value: 'ATG',
  },
  {
    text: 'Argentina',
    value: 'ARG',
  },
  {
    text: 'Armenia',
    value: 'ARM',
  },
  {
    text: 'Aruba',
    value: 'ABW',
  },
  {
    text: 'Australia',
    value: 'AUS',
  },
  {
    text: 'Austria',
    value: 'AUT',
  },
  {
    text: 'Azerbaijan',
    value: 'AZE',
  },
  {
    text: 'Bahamas',
    value: 'BHS',
  },
  {
    text: 'Bahrain',
    value: 'BHR',
  },
  {
    text: 'Bangladesh',
    value: 'BGD',
  },
  {
    text: 'Barbados',
    value: 'BRB',
  },
  {
    text: 'Belarus',
    value: 'BLR',
  },
  {
    text: 'Belgium',
    value: 'BEL',
  },
  {
    text: 'Belize',
    value: 'BLZ',
  },
  {
    text: 'Benin',
    value: 'BEN',
  },
  {
    text: 'Bermuda',
    value: 'BMU',
  },
  {
    text: 'Bhutan',
    value: 'BTN',
  },
  {
    text: 'Bolivia',
    value: 'BOL',
  },
  {
    text: 'Bonaire Sint Eustatius and Saba',
    value: 'BES',
  },
  {
    text: 'Bosnia and Herzegovina',
    value: 'BIH',
  },
  {
    text: 'Botswana',
    value: 'BWA',
  },
  {
    text: 'Bouvet Island',
    value: 'BVT',
  },
  {
    text: 'Brazil',
    value: 'BRA',
  },
  {
    text: 'British Indian Ocean Territory',
    value: 'IOT',
  },
  {
    text: 'Brunei',
    value: 'BRN',
  },
  {
    text: 'Bulgaria',
    value: 'BGR',
  },
  {
    text: 'Burkina Faso',
    value: 'BFA',
  },
  {
    text: 'Burundi',
    value: 'BDI',
  },
  {
    text: 'Cabo Verde',
    value: 'CPV',
  },
  {
    text: 'Cambodia',
    value: 'KHM',
  },
  {
    text: 'Cameroon',
    value: 'CMR',
  },
  {
    text: 'Canada',
    value: 'CAN',
  },
  {
    text: 'Cayman Islands',
    value: 'CYM',
  },
  {
    text: 'Central African Republic',
    value: 'CAF',
  },
  {
    text: 'Chad',
    value: 'TCD',
  },
  {
    text: 'Chile',
    value: 'CHL',
  },
  {
    text: 'China',
    value: 'CHN',
  },
  {
    text: 'Christmas Island',
    value: 'CXR',
  },
  {
    text: 'Cocos (Keeling) Islands',
    value: 'CCK',
  },
  {
    text: 'Colombia',
    value: 'COL',
  },
  {
    text: 'Comoros',
    value: 'COM',
  },
  {
    text: 'The Democratic Republic of the Congo',
    value: 'COD',
  },
  {
    text: 'Congo',
    value: 'COG',
  },
  {
    text: 'Cook Islands',
    value: 'COK',
  },
  {
    text: 'Costa Rica',
    value: 'CRI',
  },
  {
    text: 'Croatia',
    value: 'HRV',
  },
  {
    text: 'Cuba',
    value: 'CUB',
  },
  {
    text: 'Curaçao',
    value: 'CUW',
  },
  {
    text: 'Cyprus',
    value: 'CYP',
  },
  {
    text: 'Czech Republic',
    value: 'CZE',
  },
  {
    text: 'Côte d’Ivoire',
    value: 'CIV',
  },
  {
    text: 'Denmark',
    value: 'DNK',
  },
  {
    text: 'Djibouti',
    value: 'DJI',
  },
  {
    text: 'Dominica',
    value: 'DMA',
  },
  {
    text: 'Dominican Republic',
    value: 'DOM',
  },
  {
    text: 'Ecuador',
    value: 'ECU',
  },
  {
    text: 'Egypt',
    value: 'EGY',
  },
  {
    text: 'El Salvador',
    value: 'SLV',
  },
  {
    text: 'Equatorial Guinea',
    value: 'GNQ',
  },
  {
    text: 'Eritrea',
    value: 'ERI',
  },
  {
    text: 'Estonia',
    value: 'EST',
  },
  {
    text: 'Eswatini',
    value: 'SWZ',
  },
  {
    text: 'Ethiopia',
    value: 'ETH',
  },
  {
    text: 'Falkland Islands',
    value: 'FLK',
  },
  {
    text: 'Faroe Islands',
    value: 'FRO',
  },
  {
    text: 'Fiji',
    value: 'FJI',
  },
  {
    text: 'Finland',
    value: 'FIN',
  },
  {
    text: 'France',
    value: 'FRA',
  },
  {
    text: 'French Guiana',
    value: 'GUF',
  },
  {
    text: 'French Polynesia',
    value: 'PYF',
  },
  {
    text: 'French Southern Territories',
    value: 'ATF',
  },
  {
    text: 'Gabon',
    value: 'GAB',
  },
  {
    text: 'Gambia',
    value: 'GMB',
  },
  {
    text: 'Georgia',
    value: 'GEO',
  },
  {
    text: 'Germany',
    value: 'DEU',
  },
  {
    text: 'Ghana',
    value: 'GHA',
  },
  {
    text: 'Gibraltar',
    value: 'GIB',
  },
  {
    text: 'Greece',
    value: 'GRC',
  },
  {
    text: 'Greenland',
    value: 'GRL',
  },
  {
    text: 'Grenada',
    value: 'GRD',
  },
  {
    text: 'Guadeloupe',
    value: 'GLP',
  },
  {
    text: 'Guam',
    value: 'GUM',
  },
  {
    text: 'Guatemala',
    value: 'GTM',
  },
  {
    text: 'Guernsey',
    value: 'GGY',
  },
  {
    text: 'Guinea',
    value: 'GIN',
  },
  {
    text: 'Guinea-Bissau',
    value: 'GNB',
  },
  {
    text: 'Guyana',
    value: 'GUY',
  },
  {
    text: 'Haiti',
    value: 'HTI',
  },
  {
    text: 'Heard Island and McDonald Islands',
    value: 'HMD',
  },
  {
    text: 'Vatican City',
    value: 'VAT',
  },
  {
    text: 'Honduras',
    value: 'HND',
  },
  {
    text: 'Hong Kong',
    value: 'HKG',
  },
  {
    text: 'Hungary',
    value: 'HUN',
  },
  {
    text: 'Iceland',
    value: 'ISL',
  },
  {
    text: 'India',
    value: 'IND',
  },
  {
    text: 'Indonesia',
    value: 'IDN',
  },
  {
    text: 'Iran',
    value: 'IRN',
  },
  {
    text: 'Iraq',
    value: 'IRQ',
  },
  {
    text: 'Ireland',
    value: 'IRL',
  },
  {
    text: 'Isle of Man',
    value: 'IMN',
  },
  {
    text: 'Israel',
    value: 'ISR',
  },
  {
    text: 'Italy',
    value: 'ITA',
  },
  {
    text: 'Jamaica',
    value: 'JAM',
  },
  {
    text: 'Japan',
    value: 'JPN',
  },
  {
    text: 'Jersey',
    value: 'JEY',
  },
  {
    text: 'Jordan',
    value: 'JOR',
  },
  {
    text: 'Kazakhstan',
    value: 'KAZ',
  },
  {
    text: 'Kenya',
    value: 'KEN',
  },
  {
    text: 'Kiribati',
    value: 'KIR',
  },
  {
    text: "Democratic People's Republic of Korea",
    value: 'PRK',
  },
  {
    text: 'South Korea',
    value: 'KOR',
  },
  {
    text: 'Kuwait',
    value: 'KWT',
  },
  {
    text: 'Kyrgyzstan',
    value: 'KGZ',
  },
  {
    text: 'Laos',
    value: 'LAO',
  },
  {
    text: 'Latvia',
    value: 'LVA',
  },
  {
    text: 'Lebanon',
    value: 'LBN',
  },
  {
    text: 'Lesotho',
    value: 'LSO',
  },
  {
    text: 'Liberia',
    value: 'LBR',
  },
  {
    text: 'Libya',
    value: 'LBY',
  },
  {
    text: 'Liechtenstein',
    value: 'LIE',
  },
  {
    text: 'Lithuania',
    value: 'LTU',
  },
  {
    text: 'Luxembourg',
    value: 'LUX',
  },
  {
    text: 'Macau',
    value: 'MAC',
  },
  {
    text: 'Madagascar',
    value: 'MDG',
  },
  {
    text: 'Malawi',
    value: 'MWI',
  },
  {
    text: 'Malaysia',
    value: 'MYS',
  },
  {
    text: 'Maldives',
    value: 'MDV',
  },
  {
    text: 'Mali',
    value: 'MLI',
  },
  {
    text: 'Malta',
    value: 'MLT',
  },
  {
    text: 'Marshall Islands',
    value: 'MHL',
  },
  {
    text: 'Martinique',
    value: 'MTQ',
  },
  {
    text: 'Mauritania',
    value: 'MRT',
  },
  {
    text: 'Mauritius',
    value: 'MUS',
  },
  {
    text: 'Mayotte',
    value: 'MYT',
  },
  {
    text: 'Mexico',
    value: 'MEX',
  },
  {
    text: 'Micronesia',
    value: 'FSM',
  },
  {
    text: 'Republic of Moldova',
    value: 'MDA',
  },
  {
    text: 'Monaco',
    value: 'MCO',
  },
  {
    text: 'Mongolia',
    value: 'MNG',
  },
  {
    text: 'Montenegro',
    value: 'MNE',
  },
  {
    text: 'Montserrat',
    value: 'MSR',
  },
  {
    text: 'Morocco',
    value: 'MAR',
  },
  {
    text: 'Mozambique',
    value: 'MOZ',
  },
  {
    text: 'Myanmar',
    value: 'MMR',
  },
  {
    text: 'Namibia',
    value: 'NAM',
  },
  {
    text: 'Nauru',
    value: 'NRU',
  },
  {
    text: 'Nepal',
    value: 'NPL',
  },
  {
    text: 'Netherlands',
    value: 'NLD',
  },
  {
    text: 'New Caledonia',
    value: 'NCL',
  },
  {
    text: 'New Zealand',
    value: 'NZL',
  },
  {
    text: 'Nicaragua',
    value: 'NIC',
  },
  {
    text: 'Niger',
    value: 'NER',
  },
  {
    text: 'Nigeria',
    value: 'NGA',
  },
  {
    text: 'Niue',
    value: 'NIU',
  },
  {
    text: 'Norfolk Island',
    value: 'NFK',
  },
  {
    text: 'Northern Mariana Islands',
    value: 'MNP',
  },
  {
    text: 'Norway',
    value: 'NOR',
  },
  {
    text: 'Oman',
    value: 'OMN',
  },
  {
    text: 'Pakistan',
    value: 'PAK',
  },
  {
    text: 'Palau',
    value: 'PLW',
  },
  {
    text: 'Palestine',
    value: 'PSE',
  },
  {
    text: 'Panama',
    value: 'PAN',
  },
  {
    text: 'Papua New Guinea',
    value: 'PNG',
  },
  {
    text: 'Paraguay',
    value: 'PRY',
  },
  {
    text: 'Peru',
    value: 'PER',
  },
  {
    text: 'Philippines',
    value: 'PHL',
  },
  {
    text: 'Pitcairn',
    value: 'PCN',
  },
  {
    text: 'Poland',
    value: 'POL',
  },
  {
    text: 'Portugal',
    value: 'PRT',
  },
  {
    text: 'Puerto Rico',
    value: 'PRI',
  },
  {
    text: 'Qatar',
    value: 'QAT',
  },
  {
    text: 'Republic of North Macedonia',
    value: 'MKD',
  },
  {
    text: 'Romania',
    value: 'ROU',
  },
  {
    text: 'Russian Federation',
    value: 'RUS',
  },
  {
    text: 'Rwanda',
    value: 'RWA',
  },
  {
    text: 'Réunion',
    value: 'REU',
  },
  {
    text: 'Saint Barthélemy',
    value: 'BLM',
  },
  {
    text: 'Saint Helena',
    value: 'SHN',
  },
  {
    text: 'Saint Kitts and Nevis',
    value: 'KNA',
  },
  {
    text: 'Saint Lucia',
    value: 'LCA',
  },
  {
    text: 'Saint Martin',
    value: 'MAF',
  },
  {
    text: 'Saint Pierre and Miquelon',
    value: 'SPM',
  },
  {
    text: 'Saint Vincent and the Grenadines',
    value: 'VCT',
  },
  {
    text: 'Samoa',
    value: 'WSM',
  },
  {
    text: 'San Marino',
    value: 'SMR',
  },
  {
    text: 'Sao Tome and Principe',
    value: 'STP',
  },
  {
    text: 'Saudi Arabia',
    value: 'SAU',
  },
  {
    text: 'Senegal',
    value: 'SEN',
  },
  {
    text: 'Serbia',
    value: 'SRB',
  },
  {
    text: 'Seychelles',
    value: 'SYC',
  },
  {
    text: 'Sierra Leone',
    value: 'SLE',
  },
  {
    text: 'Singapore',
    value: 'SGP',
  },
  {
    text: 'Sint Maarten',
    value: 'SXM',
  },
  {
    text: 'Slovakia',
    value: 'SVK',
  },
  {
    text: 'Slovenia',
    value: 'SVN',
  },
  {
    text: 'Solomon Islands',
    value: 'SLB',
  },
  {
    text: 'Somalia',
    value: 'SOM',
  },
  {
    text: 'South Africa',
    value: 'ZAF',
  },
  {
    text: 'South Georgia and the South Sandwich Islands',
    value: 'SGS',
  },
  {
    text: 'South Sudan',
    value: 'SSD',
  },
  {
    text: 'Spain',
    value: 'ESP',
  },
  {
    text: 'Sri Lanka',
    value: 'LKA',
  },
  {
    text: 'Sudan',
    value: 'SDN',
  },
  {
    text: 'Suriname',
    value: 'SUR',
  },
  {
    text: 'Svalbard and Jan Mayen',
    value: 'SJM',
  },
  {
    text: 'Sweden',
    value: 'SWE',
  },
  {
    text: 'Switzerland',
    value: 'CHE',
  },
  {
    text: 'Syrian Arab Republic',
    value: 'SYR',
  },
  {
    text: 'Taiwan',
    value: 'TWN',
  },
  {
    text: 'Tajikistan',
    value: 'TJK',
  },
  {
    text: 'Tanzania',
    value: 'TZA',
  },
  {
    text: 'Thailand',
    value: 'THA',
  },
  {
    text: 'Timor-Leste',
    value: 'TLS',
  },
  {
    text: 'Togo',
    value: 'TGO',
  },
  {
    text: 'Tokelau',
    value: 'TKL',
  },
  {
    text: 'Tonga',
    value: 'TON',
  },
  {
    text: 'Trinidad and Tobago',
    value: 'TTO',
  },
  {
    text: 'Tunisia',
    value: 'TUN',
  },
  {
    text: 'Turkey',
    value: 'TUR',
  },
  {
    text: 'Turkmenistan',
    value: 'TKM',
  },
  {
    text: 'Turks and Caicos Islands',
    value: 'TCA',
  },
  {
    text: 'Tuvalu',
    value: 'TUV',
  },
  {
    text: 'Uganda',
    value: 'UGA',
  },
  {
    text: 'Ukraine',
    value: 'UKR',
  },
  {
    text: 'United Arab Emirates',
    value: 'ARE',
  },
  {
    text: 'United Kingdom',
    value: 'GBR',
  },
  {
    text: 'United States Minor Outlying Islands',
    value: 'UMI',
  },
  {
    text: 'United States',
    value: 'USA',
  },
  {
    text: 'Uruguay',
    value: 'URY',
  },
  {
    text: 'Uzbekistan',
    value: 'UZB',
  },
  {
    text: 'Vanuatu',
    value: 'VUT',
  },
  {
    text: 'Venezuela',
    value: 'VEN',
  },
  {
    text: 'Vietnam',
    value: 'VNM',
  },
  {
    text: 'British Virgin Islands',
    value: 'VGB',
  },
  {
    text: 'United States Virgin Islands',
    value: 'VIR',
  },
  {
    text: 'Wallis and Futuna',
    value: 'WLF',
  },
  {
    text: 'Western Sahara',
    value: 'ESH',
  },
  {
    text: 'Yemen',
    value: 'YEM',
  },
  {
    text: 'Zambia',
    value: 'ZMB',
  },
  {
    text: 'Zimbabwe',
    value: 'ZWE',
  },
  {
    text: 'Åland Islands',
    value: 'ALA',
  },
  {
    text: 'Republic of Kosovo',
    value: 'XKX',
  },
];
